import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';

/**
 * PreviewError Component
 * Enhanced error display with CTA to report error to chatbot
 * 
 * @param {Object} props
 * @param {string} props.error - Error message from LiveError
 * @param {Function} props.onReportError - Callback when user clicks to report error
 * @param {string} props.className - Additional CSS classes
 */
export default function PreviewError({ error, onReportError, isResolving = false, className = '' }) {
  // Don't render if there's no error
  if (!error) return null;

  return (
    <div className={`bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 ${className}`}>
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm mb-1">Preview Error</div>
          <pre className="text-xs whitespace-pre-wrap break-words font-mono bg-red-100 p-2 rounded border border-red-200 mb-3">
            {error}
          </pre>
          {onReportError && isResolving && (
            <div className="inline-flex items-center gap-2 text-xs font-medium">
              <Loader2 className="h-3.5 w-3.5 animate-spin text-red-600" />
              <span>Auto-sending this error to the chatbot to resolve…</span>
            </div>
          )}
          {onReportError && !isResolving && (
            <div className="text-xs text-red-700 font-medium">
              This error was sent to the chatbot automatically.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

